module.exports = __webpack_public_path__ + "static/img/yinliang2.183a2d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/yinliang2.png
// module id = cJj5
// module chunks = 24